export interface ProjectVideo {
  key: string;
  videoUrl: string;
  duration: string;
  thumb?: string;
}

// Project films. Titles/descriptions come from translations: projects.videos.<key>
export const PROJECT_VIDEOS: ProjectVideo[] = [
  { key: 'intro', videoUrl: '/videos/proje-1.mp4', thumb: '/video1kapak.png', duration: '' },
  { key: 'design', videoUrl: '/videos/proje-2.mp4', thumb: '/video2kapak.png', duration: '' },
  { key: 'multipurpose', videoUrl: '/videos/proje-3.mp4', thumb: '/video3kapak.png', duration: '' },
  { key: 'privateSchool', videoUrl: '/videos/proje-4.mp4', thumb: '/video4kapak.png', duration: '' },
  { key: 'economicSchool', videoUrl: '/videos/proje-5.mp4', thumb: '/video5kapak.png', duration: '' },
  { key: 'showreel', videoUrl: '/videos/proje-6.mp4', duration: '' }
];
